export const getImageWithHeight = (url, height) =>
  url ? url.replace('w=1800', '').replace('h=1800', `h=${height}`) : '';

/**
 * Sanitizes a URL by removing any characters that are not allowed in a URL.
 * @param {string} url - The URL to sanitize.
 * @returns {string} The sanitized URL.
 */

export const sanitizeUrl = url => {
  // eslint-disable-next-line no-useless-escape
  return url.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.\(\)]/g, '');
};
